import React from 'react';
import logoDark from "../../assets/images/bim-logo.png"
import { Alert, Col, Container, Row , Card, Form} from 'react-bootstrap';
import { Link } from 'react-router-dom';
import AuthCarousel from './AuthCarousel';
import { useFormik } from 'formik'
import * as Yup from "yup";
import { useDispatch, useSelector } from 'react-redux'
import { createSelector } from 'reselect'
import { userForgetPassword } from '../../slices/forgetpwd/thunk'
import {useTranslation} from "react-i18next";
import AuthFooter from "../../Layout/AuthFooter";

const ForgotPassword = (props:any) => {
    const dispatch = useDispatch();
    const {t} = useTranslation();

    const validation: any = useFormik({
        enableReinitialize: true,

        initialValues: {
            email: '',
        },
        validationSchema: Yup.object({
            email: Yup.string().required("Please Enter Your Email"),
        }),
        onSubmit: (values:any) => {
            dispatch(userForgetPassword(values, props.history));
        }
    });

    const selectForgetPassword = createSelector(
        (state: any) => state.ForgetPassword,
        (forgetPassword:any) => ({
            forgetError: forgetPassword.forgetError,
            forgetSuccessMsg: forgetPassword.forgetSuccessMsg,
        })
    );

    const { forgetError, forgetSuccessMsg } = useSelector(selectForgetPassword);
    document.title = t('ForgetPassword.title');

  return (
    <React.Fragment>
        <div className="account-pages">
            <Container>
                <Row className="justify-content-center">
                    <Col md={11}>
                        <div className="auth-full-page-content d-flex min-vh-100 py-sm-5 py-4">
                            <div className="w-100">
                                <div className="d-flex flex-column h-100 py-0 py-xl-4">
    
                                    <div className="text-center mb-5">
                                        <Link to="/">
                                            <span className="logo-lg">
                                                <img src={logoDark} alt="" height="21" />
                                            </span>
                                        </Link>
                                    </div>
    
                                    <Card className="my-auto overflow-hidden">
                                            <Row className="g-0">
                                                <Col lg={6}>
                                                    <div className="p-lg-5 p-4">
                                                        <div className="text-center">
                                                            <h5 className="mb-0">{t('ForgetPassword.header')}</h5>
                                                            <p className="text-muted mt-2">{t('ForgetPassword.subheader')}</p>
                                                        </div>

                                                        <div className="text-center my-5">
                                                            <div className="alert alert-borderless alert-warning text-center mb-2 mx-2" role="alert">
                                                                {t('ForgetPassword.description')}
                                                            </div>
                                                        </div>

                                                       
                                                    
                                                        <div className="mt-4">
                                                        {forgetError && forgetError ? (
                                                                <Alert variant="danger" style={{ marginTop: "13px" }}>
                                                                    {forgetError}
                                                                </Alert>
                                                            ) : null}
                                                            {forgetSuccessMsg ? (
                                                                <Alert variant="success" style={{ marginTop: "13px" }}>
                                                                    {forgetSuccessMsg}
                                                                </Alert>
                                                            ) : null}
                                                                <Form action=''
                                                                onSubmit={(e) => {
                                                                    e.preventDefault();
                                                                    validation.handleSubmit();
                                                                    return false;
                                                                }}>                                                            
                                                                
                                                                <Form.Group className="mb-3">
                                                                <Form.Label>{t('Login.email')}</Form.Label>
                                                                    <Form.Control
                                                                        type="email"
                                                                        name='email'
                                                                        className="form-control bg-light border-light password-input"
                                                                        id="email"
                                                                        placeholder={t('Login.email_error')}
                                                                        onChange={validation.handleChange}
                                                                        onBlur={validation.handleBlur}
                                                                        value={validation.values.email || ""}
                                                                        isInvalid={
                                                                            validation.touched.email && validation.errors.email ? true : false
                                                                        }
                                                                    />
                                                                    {validation.touched.email && validation.errors.email ? (
                                                                        <Form.Control.Feedback type="invalid">{validation.errors.email}</Form.Control.Feedback>
                                                                    ) : null}
                                                                </Form.Group>
                    
                                                                <div className="mt-2">
                                                                    <button className="btn btn-primary w-100" type="submit">{t('ForgetPassword.submit_button')} </button>
                                                                </div>

                    
                                                                <div className="mt-4 text-center">
                                                                    <p className="mb-0">{t('ForgetPassword.go_back')}  <Link to="/login" className="fw-medium text-primary text-decoration-underline">  {t('ForgetPassword.go_back_link')}  </Link> </p>
                                                                </div>
                                                            </Form>
                                                        </div>                                    
                                                    </div>
                                                </Col>
                    
                                        <AuthCarousel/>
                                                
                                        </Row>
                                    </Card>
                                    
                                    
                                    <AuthFooter />
                                </div>
                            </div>
                        </div>
                    </Col>
                    
                </Row>
                
            </Container>
            
        </div>
      
    </React.Fragment>
  )
}

export default ForgotPassword
